$('.customize-main-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight:true,
    asNavFor: '.customize-small-slider'
});
$('.customize-small-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    adaptiveHeight:true,
    asNavFor: '.customize-main-slider',
    dots: false,
    arrows: true,
    prevArrow: '<button type="button" class="mrk-slick-btn mrk-slick-prev circle-button circle-button--xs circle-button--fill border group"><span class="animated-arrow animated-arrow--reverse"></span></button>',
    nextArrow: '<button type="button" class="mrk-slick-btn mrk-slick-next circle-button circle-button--xs circle-button--fill border group"><span class="animated-arrow"></span></button>',
    focusOnSelect: true,
    responsive: [{
        breakpoint: 991,
        settings: {
            slidesToShow: 4,
            slidesToScroll: 1
        }
    }]
});
$('.mrk-name-on-bottle').on('input',function (e) { 
    if($(this).val() != ''){
        $('.mrk-upload-wrapper input[type="file"]').removeAttr('required');
    }else{
        $('.mrk-upload-wrapper input[type="file"]').attr('required',true);
    }
    enableFinalAddToCart()
});
function initSearch() {
    // Handle input event with delegation
    $('.mrk-search-bar input').unbind('input');
    $('.mrk-search-bar input').on('input', function() {
        const searchValue = $(this).val().toLowerCase();
        const linkList = $(this).parents('.mrk-custom-dropdown').find('.option-list li');
        console.log(searchValue.length, $(this));

        if (searchValue.length === 0) {
            linkList.show();
            return;
        }
        linkList.each(function() {
            const linkText = $(this).text().toLowerCase();
            linkText.includes(searchValue) ? $(this).show() : $(this).hide();
        });
    });
}
function renderBrandProducts(li){
    var url = $(li).attr('value');
    var selector = $(li).parents('.mrk-brand-fragnance-customize').find('.model-select');
    getData(url,selector);
}
function updateMeta(li){
    var container = $(li).parents('form');
    const Brand = $(container).find('.selectbottlebrand .selected-value[value]').text();
    const fragrance = $(container).find('.mrk-final-product-list .selected-value[value]').text();
    $(container).find('[name="properties[Fragrance]"]').val(fragrance);
    $(container).find('[name="properties[Brand]"]').val(Brand);
}
function initSelect(){
    $('.mrk-selected-option').unbind('click');
    $('.mrk-custom-dropdown li').unbind('click');
    $('.mrk-selected-option').click(function (e) { 
        e.preventDefault();
        $('.dropdown-wrapper').not($(this).parents('.mrk-custom-dropdown').find('.dropdown-wrapper')).slideUp('fast');
        $(this).parents('.mrk-custom-dropdown').find('.dropdown-wrapper').slideToggle('fast');
        $(this).parents('.mrk-custom-dropdown').find('.mrk-search-bar-input').focus()
    });
    $('.mrk-custom-dropdown li').click(function (e) {
        $(this).parents('.dropdown-wrapper').slideUp('fast');
        var value = $(this).attr('value');
        var text = $(this).text();
        $(this).parents('.mrk-custom-dropdown').find('.selected-value').text(text).attr('value', value);
        if($(this).parents('.mrk-custom-dropdown').hasClass('selectbottlebrand')){
            renderBrandProducts($(this))
        }
        updateMeta($(this));
        if($(this).parents('.mrk-custom-dropdown').hasClass('variant-button')){
            UpdateVariantId($(this))
        }
        enableFinalAddToCart();
    });
    $(document).click(function(e) {
        if (!$(e.target).closest('.mrk-custom-dropdown').length) {
            $('.dropdown-wrapper').slideUp('fast');
        }
    });
}
function enableFinalAddToCart() {
    $('.mrk-customize-inner').each(function(){
        const BrandLength = $(this).find('.selectbottlebrand .selected-value[value]').length;
        const checkedLength = $(this).find('.model-select .selected-value[value]').length;
        var isDisabled = checkedLength && BrandLength;
        if(!($('.mrk-upload-wrapper input[type="file"]').val() != '' || $('.mrk-name-on-bottle').val() != '' )){
            isDisabled = false;
        }
        $(this).find('.mrk-final-add-btn-customize').prop('disabled', !isDisabled);
    })
}
function getData(url,selector,callback){
    var callback = callback || function() { };
    $.ajax({
        type: "GET",
        url,
        dataType: "html",
        cache: true,
        beforeSend: function(){
            $(selector).html(`<div class="mrk-loader"><div class="lds-dual-ring"></div></div>`).addClass('mrk-loading');
        },
        success: function (response) {
            selector.html(response).removeClass('mrk-loading');
            callback();
            bindEvents();
        }
    });
}
function imageUpload(){
    $('.mrk-upload-wrapper input[type="file"]').on('change', function() {
        $('.selected-image-name').text('Upload your image');
        // Get the selected file
        var file = this.files[0];

        if (file) {
            // Check the file size (in bytes)
            var fileSize = file.size;
            var maxSize = 5 * 1024 * 1024; // 5MB

            if (fileSize > maxSize) {
                // If the file is too large
                alert('File size exceeds 10MB. Please select a smaller file.');
                // Clear the file input
                $(this).val('');
                // Clear the selected file name
                $('.selected-image-name').text('Upload your image');
            } else {
                // If file size is acceptable, update the selected file name
                $('.selected-image-name').text(file.name);
                $('.mrk-name-on-bottle').removeAttr('required');
                $('.mrk-name-on-bottle-wrapper').addClass('optional');
            }
        }else{
            $('.mrk-name-on-bottle').attr('required',true);
            $('.mrk-name-on-bottle-wrapper').removeClass('optional');
        }
        enableFinalAddToCart()
    });
}
function bindWhatsapp(){
    $('.mrk-whatsapp-bar-btn button').click(function (e) { 
        e.preventDefault();
        $('.spk-wsp-chat-btn').trigger('click');
    });
}
function bindEvents(){
    initSearch();
    initSelect();
}
function getBrands(){
  $('.mrk-brands-list').each(function(){
    var _this = $(this);
    var url = $(this).attr('url');
    $.ajax({
        type: "GET",
        url,
        dataType: "html",
        cache: true,
        success: function (response) {
            $(_this).html(response);
            bindEvents();
        }
    });
  });
}
initSelect();
initSearch();
getBrands();
enableFinalAddToCart();
imageUpload();
bindWhatsapp()